<template>
    <div>
        <b-modal
            size="lg"
            v-model="modalShow"
            title="請求"
            ok-title="確認画面へ"
            ok-variant="yokumiru-orange"
            cancel-title="キャンセル"
            cancel-variant="yokumiru-gray"
            :ok-disabled="inProgress"
            :cancel-disabled="inProgress"
            @ok="handleOk"
            @cancel="cancel"
            @hidden="cancel">
            <form @submit.stop.prevent="confirmInvoice">
                <div class="form-group row align-items-center">
                    <label
                        class="col-lg-2 col-form-label is-required-ja"
                        :class="{ 'mb-errors' : errors.amount }"
                        for="amount">
                        請求金額
                    </label>
                    <div class="col-lg-10">
                        <div class="d-flex align-items-center">
                            <input
                                v-model="invoice.amount"
                                id="amount"
                                style="max-width: 400px;"
                                class="form-control"
                                :class="{ 'is-invalid' : errors.amount }"
                                type="number"
                                placeholder="0">
                            <span class="small">&nbsp;円</span>
                        </div>

                        <div v-if="errors.amount" class="invalid-feedback d-block mt-1">
                            {{ errors.amount[0] }}
                        </div>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label
                        class="col-lg-2 col-form-label"
                        :class="{ 'mb-errors' : errors.attachments }">
                        ファイル添付
                    </label>
                    <div class="col-lg-10">
                        <b-form-file
                            v-model="invoice.attachments"
                            multiple
                            ref="attachments"
                            placeholder=""
                            style="max-width: 600px;"
                            :class="{ 'is-invalid' : errors.attachments }"
                            accept="image/jpeg, image/png, image/gif, application/pdf">
                        </b-form-file>

                        <div v-if="errors.attachments" class="invalid-feedback d-block mt-1">
                            {{ errors.attachments[0] }}
                        </div>
                    </div>
                    <div v-if="errors.message" class="invalid-feedback d-flex justify-content-center mt-3">
                        {{ errors.message[0] }}
                    </div>
                </div>
            </form>
        </b-modal>

        <manual-confirm-invoice-modal/>
    </div>
</template>

<script>
    import constants from "../../../constants";

    export default {
        name: 'StoreInvoiceModal',

        data: function() {
            return {
                inProgress :false,
                modalShow: false,
                consultation: null,
                userType: null,
                invoice: {
                  amount: null,
                  attachments: [],
                },
                errors: {},
            }
        },

        created: function () {
            bus.$on('open-modal-store-invoice', this.open)
            bus.$on('invoice-attempted', this.close)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-store-invoice')
            bus.$off('invoice-attempted')
        },

        methods: {
            open: function (consultation, userType) {
                this.consultation = consultation
                this.userType = userType
                this.modalShow = true
            },

            handleOk(e) {
                e.preventDefault()
                this.confirmInvoice()
            },

            confirmInvoice: async function () {
                if (this.inProgress) return
                this.inProgress = true

                let endpoint = ''
                const options = { headers: { 'Content-Type': 'multipart/form-data' } }

                if (this.userType === 'admin') {
                    endpoint = `${constants.admin.consultations.endpoint.base}/${this.consultation.id}/invoices`
                }
                else if (this.userType === 'doctor') {
                    endpoint = `${constants.doctor.consultations.endpoint.base}/${this.consultation.id}/invoices`
                }

                await axios.post(`${endpoint}/confirm`, this.buildFormData(), options)
                    .then(() => {
                        bus.$emit('open-modal-confirm-invoice', this.consultation, this.invoice, this.userType)
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            buildFormData: function () {
                const data = new FormData()
                data.append('amount', this.invoice.amount)

                if (this.invoice.attachments.length > 0) {
                    this.invoice.attachments.forEach(attachment => {
                        data.append('attachments[]', attachment)
                    })
                }

                return data
            },

            cancel: function () {
                this.initialize()
                this.close()
            },

            close: function () {
                this.initialize()
                this.modalShow = false
            },

            initialize: function() {
                this.consultation = null
                this.invoice = { amount: null, attachments: [] }
                this.errors = {}
            },
        },
    }
</script>

<style scoped lang="scss">
    @media only screen and (min-width: 992px) {
        .mb-errors {
            margin-bottom: 22px;
        }
    }
</style>
